import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { Mail, Linkedin } from 'lucide-react';

const TEAM_MEMBERS = [
  {
    name: 'Javan Braga',
    role: 'CEO',
    email: 'javan.braga@7x7travel.pt',
    image: 'https://customer-assets.emergentagent.com/job_951b775e-9609-4ec6-b6b9-987a8442de3a/artifacts/ie96u1lf_Javan%20Braga.png',
    bio: {
      pt: 'Javan Braga, CEO da 7x7 Travel, é a pessoa que, há mais de 8 anos, lidera a empresa com foco em crescimento estratégico, inovação e excelência no atendimento. Atua no desenvolvimento de parcerias sólidas e na criação de experiências de viagem diferenciadas, consolidando a marca como referência no mercado turístico.',
      en: 'Javan Braga, CEO of 7x7 Travel, has been leading the company for over 8 years with a focus on strategic growth, innovation, and service excellence. He works on developing solid partnerships and creating differentiated travel experiences, consolidating the brand as a reference in the tourism market.',
      es: 'Javan Braga, CEO de 7x7 Travel, es la persona que, desde hace más de 8 años, lidera la empresa con enfoque en crecimiento estratégico, innovación y excelencia en el servicio. Actúa en el desarrollo de alianzas sólidas y en la creación de experiencias de viaje diferenciadas, consolidando la marca como referencia en el mercado turístico.'
    }
  },
  {
    name: 'Fátima Pinto',
    role: 'COO',
    email: 'fatimapinto@7x7travel.pt',
    image: 'https://customer-assets.emergentagent.com/job_951b775e-9609-4ec6-b6b9-987a8442de3a/artifacts/rmbzl9q7_Fatima%20Pinto.png',
    bio: {
      pt: 'Fátima Pinto é COO da 7x7 Travel desde sua fundação, com atuação estratégica na gestão operacional e forte liderança na área comercial. Responsável por impulsionar resultados, fortalecer parcerias e expandir oportunidades de negócio, alia eficiência operacional a uma abordagem comercial dinâmica e orientada para o crescimento sustentável da empresa.',
      en: 'Fátima Pinto has been COO of 7x7 Travel since its founding, with strategic involvement in operational management and strong leadership in the commercial area. Responsible for driving results, strengthening partnerships, and expanding business opportunities, she combines operational efficiency with a dynamic commercial approach oriented towards sustainable company growth.',
      es: 'Fátima Pinto es COO de 7x7 Travel desde su fundación, con actuación estratégica en la gestión operativa y fuerte liderazgo en el área comercial. Responsable de impulsar resultados, fortalecer alianzas y expandir oportunidades de negocio, combina eficiencia operativa con un enfoque comercial dinámico orientado al crecimiento sostenible de la empresa.'
    }
  },
  {
    name: 'Renan Braguim',
    role: 'Tecnologia',
    email: 'renambraguim@7x7travel.pt',
    image: 'https://customer-assets.emergentagent.com/job_951b775e-9609-4ec6-b6b9-987a8442de3a/artifacts/u2sy622x_Renan%20Braguim.png',
    bio: {
      pt: 'Renan Braguim integra o departamento de Tecnologia da 7x7 Travel, sendo responsável pela inovação, otimização de sistemas e desenvolvimento de soluções que fortalecem a eficiência da empresa. Além da atuação técnica, contribui ativamente na área comercial, apoiando estratégias de crescimento, integração de ferramentas e geração de novas oportunidades de negócio.',
      en: 'Renan Braguim is part of the Technology department at 7x7 Travel, responsible for innovation, system optimization, and developing solutions that strengthen company efficiency. Beyond technical work, he actively contributes to the commercial area, supporting growth strategies, tool integration, and generating new business opportunities.',
      es: 'Renan Braguim integra el departamento de Tecnología de 7x7 Travel, siendo responsable de la innovación, optimización de sistemas y desarrollo de soluciones que fortalecen la eficiencia de la empresa. Además de la actuación técnica, contribuye activamente en el área comercial, apoyando estrategias de crecimiento, integración de herramientas y generación de nuevas oportunidades de negocio.'
    }
  },
  {
    name: 'Sofia Pedrosa',
    role: 'Comercial',
    email: 'sofiapedrosa@7x7travel.pt',
    image: 'https://customer-assets.emergentagent.com/job_experiencias-travel/artifacts/5hpcrej0_Sofia%20Pedrosa.png',
    bio: {
      pt: 'Sofia Pedrosa integra o Departamento Comercial da 7x7 Travel, sendo responsável pelo atendimento e acompanhamento das agências de viagens parceiras. Com forte orientação para o cliente e foco em resultados, atua na gestão de contas, desenvolvimento de oportunidades e fortalecimento das relações comerciais, contribuindo diretamente para o crescimento e consolidação da empresa no mercado.',
      en: 'Sofia Pedrosa is part of the Commercial Department at 7x7 Travel, responsible for serving and supporting partner travel agencies. With a strong customer orientation and focus on results, she works on account management, opportunity development, and strengthening commercial relationships, directly contributing to the company\'s growth and market consolidation.',
      es: 'Sofia Pedrosa integra el Departamento Comercial de 7x7 Travel, siendo responsable de la atención y seguimiento de las agencias de viajes asociadas. Con fuerte orientación al cliente y enfoque en resultados, actúa en la gestión de cuentas, desarrollo de oportunidades y fortalecimiento de las relaciones comerciales, contribuyendo directamente al crecimiento y consolidación de la empresa en el mercado.'
    }
  },
  {
    name: 'Ana Oliveira',
    role: 'Grupos e Circuitos',
    email: 'anaoliveira@7x7.travel',
    image: 'https://customer-assets.emergentagent.com/job_experiencias-travel/artifacts/85rox7hd_Ana%20Oliveira.png',
    bio: {
      pt: 'Ana Oliveira integra o departamento de Grupos e Excursões da 7x7 Travel, sendo responsável pelo planeamento, organização e coordenação de viagens em grupo. Com forte capacidade de negociação e atenção ao detalhe, garante experiências bem estruturadas, eficientes e memoráveis, contribuindo diretamente para a satisfação dos clientes e o fortalecimento das parcerias da empresa.',
      en: 'Ana Oliveira is part of the Groups and Tours department at 7x7 Travel, responsible for planning, organizing, and coordinating group travel. With strong negotiation skills and attention to detail, she ensures well-structured, efficient, and memorable experiences, directly contributing to customer satisfaction and strengthening company partnerships.',
      es: 'Ana Oliveira integra el departamento de Grupos y Excursiones de 7x7 Travel, siendo responsable de la planificación, organización y coordinación de viajes en grupo. Con fuerte capacidad de negociación y atención al detalle, garantiza experiencias bien estructuradas, eficientes y memorables, contribuyendo directamente a la satisfacción de los clientes y al fortalecimiento de las alianzas de la empresa.'
    }
  },
  {
    name: 'Sílvia Lamas',
    role: 'Contabilidade',
    email: 'silvialamas@7x7travel.pt',
    image: 'https://customer-assets.emergentagent.com/job_951b775e-9609-4ec6-b6b9-987a8442de3a/artifacts/3mcsj4aq_Silvia%20Lamas.png',
    bio: {
      pt: 'Sílvia Lamas integra o departamento Financeiro e de Contabilidade da 7x7 Travel, sendo responsável pela gestão financeira, controlo orçamental e organização contabilística da empresa. Com rigor, responsabilidade e visão estratégica, assegura a sustentabilidade financeira e o equilíbrio das operações, contribuindo para um crescimento sólido e estruturado.',
      en: 'Sílvia Lamas is part of the Finance and Accounting department at 7x7 Travel, responsible for financial management, budget control, and company accounting organization. With rigor, responsibility, and strategic vision, she ensures financial sustainability and operational balance, contributing to solid and structured growth.',
      es: 'Sílvia Lamas integra el departamento Financiero y de Contabilidad de 7x7 Travel, siendo responsable de la gestión financiera, control presupuestario y organización contable de la empresa. Con rigor, responsabilidad y visión estratégica, asegura la sostenibilidad financiera y el equilibrio de las operaciones, contribuyendo a un crecimiento sólido y estructurado.'
    }
  }
];

export default function Team() {
  const { t, language } = useLanguage();

  return (
    <div>
      {/* Hero Section */}
      <section className="pt-28 pb-16 bg-gradient-to-br from-[#1E3A8A] to-[#0F172A]" data-testid="team-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            className="text-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <span className="inline-block px-4 py-2 bg-[#00D4FF]/20 text-[#00D4FF] rounded-full text-sm font-medium mb-6">
              7x7 Travel
            </span>
            <h1 className="text-4xl sm:text-5xl font-bold text-white mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
              {t('team.title')}
            </h1>
            <p className="text-lg text-slate-300 max-w-2xl mx-auto">
              {t('team.subtitle')}
            </p>
          </motion.div>
        </div>
      </section>

      {/* Team Grid */}
      <section className="py-24 bg-[#F8FAFC]" data-testid="team-grid">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {TEAM_MEMBERS.map((member, index) => (
              <motion.div
                key={member.name}
                className="group bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-300"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                data-testid={`team-member-${index}`}
              >
                {/* Image */}
                <div className="relative h-72 overflow-hidden bg-slate-100">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    style={{ imageRendering: 'crisp-edges' }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  
                  {/* Hover Content */}
                  <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                    <a
                      href={`mailto:${member.email}`}
                      className="flex items-center gap-2 text-white hover:text-[#00D4FF] transition-colors"
                    >
                      <Mail className="w-5 h-5" />
                      <span className="text-sm">{member.email}</span>
                    </a>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <div>
                      <h3 className="text-xl font-bold text-[#0F172A]" style={{ fontFamily: 'Outfit, sans-serif' }}>
                        {member.name}
                      </h3>
                      <span className="text-[#00D4FF] font-medium">{member.role}</span>
                    </div>
                  </div>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    {member.bio[language]}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Join Team CTA */}
      <section className="py-24 bg-white" data-testid="team-cta">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            className="text-center p-12 bg-gradient-to-br from-[#1E3A8A] to-[#0F172A] rounded-3xl"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl font-bold text-white mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Quer fazer parte da nossa equipa?
            </h2>
            <p className="text-slate-300 mb-6 max-w-xl mx-auto">
              Estamos sempre à procura de pessoas talentosas e apaixonadas pelo turismo.
            </p>
            <a
              href="mailto:info@7x7travel.pt"
              className="inline-flex items-center gap-2 bg-[#00D4FF] hover:bg-[#00D4FF]/90 text-[#0F172A] rounded-full px-8 py-3 font-semibold transition-colors"
            >
              <Mail className="w-5 h-5" />
              Enviar Candidatura
            </a>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
